(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productgrid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__jhonGridInitialized) return;
    window.__jhonGridInitialized = true;

    function initDots(section) {
      var grid = section.querySelector('[data-jhon-grid]');
      var dotsWrap = section.querySelector('[data-jhon-grid-dots]');
      if (!grid || !dotsWrap) return;

      var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-jhon-grid-dot]'));
      var items = Array.prototype.slice.call(grid.querySelectorAll('.jhon-grid__cell'));
      if (!dots.length || !items.length) return;

      function setActive(index) {
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      function activeIndexFromScroll() {
        var gridRect = grid.getBoundingClientRect();
        var closestIndex = 0;
        var closestDistance = Infinity;
        items.forEach(function (item, i) {
          var itemRect = item.getBoundingClientRect();
          var distance = Math.abs(itemRect.left - gridRect.left);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = i;
          }
        });
        return closestIndex;
      }

      var ticking = false;
      grid.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          setActive(activeIndexFromScroll());
          ticking = false;
        });
      });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var item = items[i];
          if (!item) return;
          grid.scrollTo({ left: item.offsetLeft - grid.offsetLeft, behavior: 'smooth' });
        });
      });
    }

    document.querySelectorAll('[data-jhon-grid-section]').forEach(initDots);
  })();

  } catch(e) { console.error(e); }
})();
})();
